// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QJaT","top":"styles_top__1ZZrr","left":"styles_left__28yH3","description":"styles_description__3lIeI"};